import { Boxes, LayoutDashboard, Mail, Megaphone } from 'lucide-react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';

const marketingSections = [
  { label: 'Centrum', to: '/marketing', icon: LayoutDashboard, end: true },
  { label: 'Baza produktów', to: '/marketing/baza-produktow', icon: Boxes, end: false },
  { label: 'Email', to: '/marketing/email', icon: Mail, end: false },
] as const;

export function MarketingLayoutPage() {
  const location = useLocation();
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-2 overflow-x-auto rounded-card border border-border-subtle bg-surface-raised/40 p-2">
        <nav aria-label="Sekcje Marketingu" className="flex min-w-max items-center gap-2">
          {marketingSections.map(section => (
            <NavLink
              key={section.to}
              to={section.to}
              end={section.end}
              className={({ isActive }) => [
                'inline-flex items-center gap-2 rounded-lg border px-4 py-2 text-sm font-medium transition-colors',
                'focus:outline-none focus-visible:ring-2 focus-visible:ring-accent-primary/50',
                (isActive || (section.label === 'Baza produktów' && location.pathname.startsWith('/marketing/laboratorium')))
                  ? 'border-accent-primary/30 bg-accent-primary/15 text-text-primary'
                  : 'border-transparent text-text-secondary hover:border-border-subtle hover:bg-surface-hover/50 hover:text-text-primary',
              ].join(' ')}
            >
              <section.icon className="h-4 w-4" aria-hidden="true" />
              {section.label}
            </NavLink>
          ))}
        </nav>

        <div className="ml-auto min-w-max">
          <span
            className="inline-flex cursor-not-allowed items-center gap-2 rounded-lg border border-border-subtle px-4 py-2 text-sm font-medium text-text-disabled"
            aria-disabled="true"
            title="Moduł Reklamy powstanie w kolejnej fazie"
          >
            <Megaphone className="h-4 w-4" aria-hidden="true" />
            Reklamy
            <span className="rounded-badge bg-surface-hover px-2 py-0.5 text-xxs uppercase tracking-wide text-text-muted">
              Później
            </span>
          </span>
        </div>
      </div>

      <Outlet />
    </div>
  );
}
